<template>
  <div v-if="currentActivityImagesRequest === numberOfActivityImagesRequest  && ready">
    <div v-for="(poi, index) in itinerario.poi" :key="'poi' + (index + 200)">
      <div
        v-for="(it, ind) in poi.activitiesOfPOIPivot"
        :key="'availableActivities' + (ind + 200)"
        class="row"
      >
        <div class="col-12">
          <div class="row" v-if="ind > 0">
            <div class="col-12 pl-4">
              <div class="vertical-line-same-poi ml-5"></div>
            </div>
          </div>

          <div
            class="row mx-1 mb-0 itinerary-card orange"
            style="border-radius: 10px"
          >
            <div
              class="col-12 text-center px-0"
              style="
                background-color: #4f9bff; 
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                cursor: pointer;

                display: flex;

                justify-content: center;
                align-items: center;
                color: #ffffff;
                height: 12rem;
              "
            >
              <img
                v-if="ind === 0 && poi.mediaImages.length > 0"
                :src="poi.mediaImages[0]['thumbnail_display_urls']['large']"
                v-img="{
                  group: getGroupName(poi) + ind + 'Mobile',
                }"
                :alt="poi['geo:Titolo_it'][0]['@value']"
                style="
                  height: 100%;
                  width: 100%;
                  border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                "
              />
              <img
                v-else-if="ind > 0 && it.media && it.media.length > 0"
                :src="it.media[0]['thumbnail_display_urls']['large']"
                v-img="{
                  group: getGroupName(poi) + ind + 'Mobile',
                }"
                :alt="it['o:title']"
                style="
                  height: 100%;
                  width: 100%;
                  border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                "
              />
              <img
                v-else
                v-img="{
                  group: getGroupName(poi) + ind + 'Mobile',
                }"
                :alt="poi['geo:Titolo_it'][0]['@value']"
                src="@/assets/images/noPhotoAvailable.png"
                style="
                  height: 100%;
                  width: 100%;
                  border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                "
              />
            </div>
            <div class="col-12 text-left py-2">
              <div class="row text-center mt-2">
                <div class="col-12">
                  <h5>
                    <b>{{ it["o:title"].toUpperCase() }}</b>
                  </h5>
                </div>
              </div>
              <div class="row text-center mt-2">
                <div class="col-6" style="border-right: 1px ridge">
                  <div class="row text-center">
                    <div class="col-12">
                      <i class="bi bi-pin-map-fill mr-2"></i>
                    </div>
                  </div>
                  <div class="row text-center">
                    <div class="col-12">
                      <h6 style="font-weight: 600">
                        {{ poi["geo:Titolo_it"][0]["@value"] }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row text-center">
                    <div class="col-12">
                      <i class="bi bi-clock mr-2"></i>
                    </div>
                  </div>
                  <div class="row text-center">
                    <div class="col-12">
                      <h6 style="font-weight: 600">
                        {{ it["geo:Durata"][0]["@value"] }}
                        minuti
                        <template v-if="ind > 0">
                    <template
                      v-if="
                        it['geo:Durata_organizzazione'] &&
                        parseInt(it['geo:Durata_organizzazione'][0]['@value']) >
                          1
                      "
                      >+
                      {{ it["geo:Durata_organizzazione"][0]["@value"] }} minuti
                      di organizzazione</template
                    >
                    <template
                      v-else-if="
                        it['geo:Durata_organizzazione'] &&
                        parseInt(it['geo:Durata_organizzazione'][0]['@value']) >
                          0
                      "
                      >+ {{ it["Durata_organizzazione"][0]["@value"] }} minuto
                      di organizzazione</template
                    >
                    <template
                      v-else
                      >+ {{ config.omekaIDs.defaultOrganizationTime }} minuti
                      di organizzazione</template
                    > 
                  </template>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center mt-4 mb-2">
                <div class="col-12">
                  <div class="row text-center">
                    <div class="col-12">
                      <h6 style="font-weight: 600">
                        <i class="bi bi-info-circle mr-2"></i>
                        <template v-if="it['geo:ha_tipologia_attivita']">
                          {{
                            it["geo:ha_tipologia_attivita"][0]["display_title"]
                          }}
                        </template>
                        <template v-else> Visita del luogo </template>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-12">
                  <Button
                    type="primary"
                    size="small"
                    v-on:click="
                      isGeodidalab
                        ? selectMarkerOnMap(
                            poi['geo:Titolo_it'][0]['@value'],
                            it['o:title'],
                            poi['areaDiAppartenenza'][0]['display_title']
                          )
                        : selectMarkerOnMapIstitutoMosso(
                            poi['geo:Titolo_it'][0]['@value'],
                            it['o:title']
                          )
                    "
                    class="m-2 button_font"
                    >Visualizza dettagli
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="index < itinerario.poi.length - 1" class="row mb-0 pl-5">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="vertical-line ml-2"></div>
            </div>
          </div>
          <div class="row mt-2 mb-1">
            <div class="col-12">
              <b
                ><i class="bi bi-clock mr-2"></i>
                {{ getTimeToNextPOI(poi, itinerario.poi[index + 1]) }}</b
              >
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="vertical-line ml-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="loader">
      <svg class="circular">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="5"
          stroke-miterlimit="10"
        ></circle>
      </svg>
    </div>
  </div>
</template>

<script>
const Common = require("@/Common.vue").default;

import $ from "jquery";
import store from "../../../store";
import { Button } from "element-ui";

import { config } from "../../../utils/config";

export default {
  name: "elenco-poi-sm",
  props: ["itinerario"],

  components: {
    Button,
  },

  data() {
    return {
      selectedTab: "Panoramica",
      windowWidth: 0,
      isLoadingImages: true,
      isLoadingVideos: true,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isMobile: false,
      isGeodidalab: false,

      numberOfActivityImagesRequest: 0,
      currentActivityImagesRequest: 0,

      config: null,
      ready: false,
    };
  },
  created() {},

  methods: {
    getGroupName(item) {
      return item["geo:Titolo_it"][0]["@value"].replaceAll('"', "");
    },
    getGroupNameMarker(marker) {
      return marker.POItitle.replaceAll('"', "");
    },
    getTimeToNextPOI(poi, nextPOI) {
      var timesFromPOI = [];

      if (poi["geo:appartiene_a_pivot"]) {
        timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
          (p) =>
            parseInt(p["PoiID"]) ===
            poi["geo:appartiene_a_pivot"][0]["value_resource_id"]
        );
      } else {
        timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
          (p) =>
            parseInt(p["PoiID"]) ===
            poi["geo:situato_in"][0]["value_resource_id"]
        );
      }

      var timeMillis = 0;
      if (timesFromPOI.length === 0) {
        timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
      } else {
        if (poi["geo:appartiene_a_pivot"]) {
          if (
            timesFromPOI[0][
              nextPOI["geo:appartiene_a_pivot"][0]["value_resource_id"]
            ]
          ) {
            timeMillis =
              timesFromPOI[0][
                nextPOI["geo:appartiene_a_pivot"][0]["value_resource_id"]
              ];
          } else {
            timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
          }
        } else {
          if (
            timesFromPOI[0][nextPOI["geo:situato_in"][0]["value_resource_id"]]
          ) {
            timeMillis =
              timesFromPOI[0][
                nextPOI["geo:situato_in"][0]["value_resource_id"]
              ];
          } else {
            timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
          }
        }
      }

      var timeMinutes = timeMillis / 60000;

      if (timeMinutes === 1) {
        return timeMinutes + " minuto";
      } else {
        return timeMinutes + " minuti";
      }
    },
    selectMarkerOnMapIstitutoMosso(poiName, activityName) {
      this.$emit("selectMarkerOnMapIstitutoMosso", poiName, activityName);
    },
    selectMarkerOnMap(poiName, activityName, areaName) {
      this.$emit("selectMarkerOnMap", poiName, activityName, areaName);
    },
  },
  computed: {},

  mounted() {
    this.config = config;
    this.ready = true;

    var numberOfActivityImagesRequest = 0;

    Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
      Array.prototype.forEach.call(
        poi.activitiesOfPOIPivot.slice(1, poi.activitiesOfPOIPivot.length),
        (activity) => {
          numberOfActivityImagesRequest++;
        }
      );
    });

    this.numberOfActivityImagesRequest = numberOfActivityImagesRequest;

    Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
      Array.prototype.forEach.call(
        poi.activitiesOfPOIPivot.slice(1, poi.activitiesOfPOIPivot.length),
        (activity) => {
          Common.getElementImages(this, activity, (mediaList) => {
            activity.media = mediaList;
            this.currentActivityImagesRequest++;
          });
        }
      );
    });
  },
};
</script>

<style lang="scss">
.img {
  align-items: center;
  height: 100%;
  object-fit: cover;
  border-radius: 10px 10px 0px 0px;
}

.text {
  height: 15rem;
  overflow: scroll;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.card-body {
  padding: 0 !important;
}

.custom-image-slider {
  height: 270px !important;
}

.slider-indicator-icon {
  background-color: rgba(0, 0, 0, 0.458) !important;
}

.slider-indicator-active {
  background-color: white !important;
}
</style>